import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  // Auto-scroll to top on every route change
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);

  // Show back-to-top button after scrolling 400px
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    // Dock slot 3 — sits above the mentor button, which sits above Account.
    <div className="fixed bottom-[196px] right-4 z-[60] print:hidden lg:bottom-[132px]">
      <Button
        variant="ghost"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Back to top of page"
        className="h-9 gap-1.5 rounded-full border border-border/60 bg-background/70 px-3 text-[13px] font-medium text-foreground/90 shadow-sm backdrop-blur-xl transition-colors hover:bg-background/90"
      >
        <ArrowUp className="h-3.5 w-3.5" aria-hidden="true" />
        <span>Top</span>
      </Button>
    </div>
  );
}

